import React, { useEffect, useState } from "react";
import { Link, Navigate, useParams } from "react-router-dom";
import { FiArrowLeft } from "react-icons/fi";
import Navbar from "../../components/shared/Navbar/Navbar";
import { careersJobs } from "../../data/careersJobs";
import "./CareerDetails.css";
import { getCareerJobByKey } from "../../api/careers";

const CareerDetails = () => {
  const { jobId } = useParams();
  const [apiJob, setApiJob] = useState(undefined);

  useEffect(() => {
    let isMounted = true;
    const load = async () => {
      try {
        const data = await getCareerJobByKey(jobId);
        if (isMounted) setApiJob(data || null);
      } catch {
        if (isMounted) setApiJob(null);
      }
    };
    load();
    return () => {
      isMounted = false;
    };
  }, [jobId]);

  const fallbackJob = careersJobs.find((item) => item.id === jobId);
  const job = apiJob === undefined ? fallbackJob : (apiJob || fallbackJob);

  if (apiJob === undefined && !fallbackJob) {
    return null;
  }

  if (!job) {
    return <Navigate to="/careers" replace />;
  }

  return (
    <div className="careerDetailsPage">
      <Navbar theme="dark" />

      <main className="careerDetails">
        <div className="careerDetails-container">
          <Link to="/careers" className="careerDetails-back">
            <FiArrowLeft aria-hidden />
            <span>Back to careers</span>
          </Link>

          <h1 className="careerDetails-title">{job.title}</h1>

          <div className="careerDetails-meta">
            <div>
              <span>Department</span>
              <p>{job.department}</p>
            </div>
            <div>
              <span>Contract type</span>
              <p>{job.employmentType || job.type}</p>
            </div>
            <div>
              <span>Location</span>
              <p>{job.location}</p>
            </div>
            <div>
              <span>Deadline</span>
              <p>{job.deadline || (job.deadlineUtc ? new Date(job.deadlineUtc).toLocaleDateString() : "-")}</p>
            </div>
          </div>

          <Link to={`/careers/${job.jobKey || job.id}/apply`} className="careerDetails-applyBtn">
            Apply now
          </Link>

          <section className="careerDetails-block">
            <h2>Job description</h2>
            <p>{job.description}</p>
          </section>

          <section className="careerDetails-block">
            <h2>Requirements</h2>
            <p>We are looking for someone who:</p>
            <ul>
              {(job.requirements || []).map((item, idx) => (
                <li key={item?.id || idx}>{typeof item === "string" ? item : item?.text}</li>
              ))}
            </ul>
          </section>

          <section className="careerDetails-block">
            <h2>How to apply</h2>
            <p>{job.howToApply}</p>
          </section>
        </div>
      </main>
    </div>
  );
};

export default CareerDetails;

